"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 09.11.2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowTypeConverter.
 *
 * @author ZSt
 */


var DummyWindowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DummyWindowConverter, _DataObjectConverter_);

  function DummyWindowConverter() {
    _classCallCheck(this, DummyWindowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowConverter).apply(this, arguments));
  }

  return DummyWindowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DummyWindowConverter = DummyWindowConverter;